module.exports = __webpack_public_path__ + "img/en-complaint.e0459162.svg";